import { render } from "./Calculator.vue?vue&type=template&id=66024012&bindings={\"msg\":\"props\",\"quantity\":\"data\",\"size\":\"data\",\"abv\":\"data\",\"price\":\"data\",\"totalExcise\":\"options\",\"vessleInLtrs\":\"options\",\"totalVolume\":\"options\",\"costPerLtr\":\"options\",\"costPerLtrPostExcise\":\"options\"}"
import script from "./Calculator.vue?vue&type=script&lang=js"
export * from "./Calculator.vue?vue&type=script&lang=js"
script.render = render

export default script